<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="datumList.length == 0 ? '' : '暂无更多资料'"
      
      @load="getDatumPinList"
    >
      <van-row v-if="datumList.length > 0 && getTokenType()">
        <van-col
          :span="24"
          class="bg-white data m-t-05"
          v-for="(item, index) in datumList"
          :key="index"
        >
          <van-row>
            <van-col :span="4">
              <svg class="icon" aria-hidden="true" style="font-size: 2.2rem">
                <use xlink:href="#icon-wenjianjia-1"></use>
              </svg>
            </van-col>
            <van-col :span="16">
              <div class="van-multi-ellipsis--l2 f-s-7" style="color: #292e35">
                {{ item.title }}
              </div>
            </van-col>
            <van-col :span="4">
              <van-icon :name="down" size="2.2rem" @click="look(item)" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    <NoData v-else text="您还没有购买资料,先去看看优质资料吧" path="/BIMList" :empty="empty"/>

    </van-list>
  </div>
</template>

<script>
import "@/assets/icon/iconfont.js";
export default {
  props: {
    datumList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      folder: require("@/assets/imgs/folder.png"),
      down: require("@/assets/imgs/mine/down.png"),
      empty: require("@/assets/imgs/empty/noData.png"),
      shareUrl: "",
      dataList: [],
      pageIndex: 1,
      loading: false,
      finished: false,
    };
  },
  methods: {
    // 查看资料列表
    look(item) {
      this.$router.push({
        path: "/lookData",
        query: {
          pid: item.pid,
        },
      });
    },
    getSuccDatePin() {},
    getDatumPinList() {
      this.$emit("getDatumList");
    },
  },
};
</script>

<style lang="less" scoped>
@import "//at.alicdn.com/t/font_2499979_etw8ns6bg4h.css";
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.data {
  padding-left: 0.5rem;
  padding-top: 0.5rem;
}
</style>